import LoadingSpinner from '@/components/loading-spinner.vue'
import PopoverInline from '@/components/popover-inline.vue'
import MenuContents from '@/components/menu-contents.vue'
import ToggleSwitch from '@/components/toggle-switch.vue'
import BibDisplay from '@/components/bib-display.vue'
import DateInput from '@/components/date-input.vue'
import DatetimePicker from '@/components/datetime-picker.vue'

export default function registerComponents(app) {
  app.component('LoadingSpinner', LoadingSpinner)
  app.component('PopoverInline', PopoverInline)
  app.component('MenuContents', MenuContents)
  app.component('ToggleSwitch', ToggleSwitch)
  app.component('BibDisplay', BibDisplay)
  app.component('DateInput', DateInput)
  app.component('DatetimePicker', DatetimePicker)
}
